module.exports = __webpack_public_path__ + "img/ParkinJ.129be9d4.jpg";